import React, { Component } from 'react';
import uuid from 'uuid';

import { Link } from 'react-router-dom';

import { RenderImageAd } from './style';

import ActionButton from '../ActionButton';

export default class List extends Component {
	constructor(props) {
		super(props);

		this.renderCols = this.renderCols.bind(this);
		this.renderData = this.renderData.bind(this);
	}

	handleClick(column, sort) {
		const { changeSorting } = this.props;

		changeSorting(column, sort);
	}

	renderCols() {
		const { keys } = this.props;

		return keys.map(value => (
			<th
				key={value.id}
			>
				{value.title}
			</th>
		));
	}

	renderData() {
		const {
			elements, actions, keys, funcDelete,
		} = this.props;

		return elements.map((element) => {
			const url = `${window.location.href}/${element.id}`;
			let valueActions = '';

			if (actions) {
				valueActions = actions.map((data) => {
					if (data.action === 'delete') {
						return (
							<ActionButton
								id={element.id}
								base_url={url}
								name={data.name}
								action={data.action}
								func={funcDelete}
								key={uuid.v4()}
							/>
						);
					}

					return (
						<Link
							to={{
								pathname: `${data.link}/${element.id}`,
								action: 'editUser',
							}}
							key={uuid.v4()}
						>
							<ActionButton
								id={element.id}
								base_url={url}
								name={data.name}
								action={data.action}
							/>
						</Link>
					);
				});
			}

			const cells = keys.map((key) => {
				if (key.col === 'text_ads') {
					return (
						<td key={key.id} className="container-link-google">
							<a
								href={element[key.col].link}
								className="link-google"
								target="_blank"
								rel="noopener noreferrer"
							>
								{element[key.col].text}
							</a>
							<cite>
								<a
									href={element[key.col].link}
									target="_blank"
									rel="noopener noreferrer"
								>
									<i className="fas fa-ad mr-1" /> {element[key.col].link}
								</a>
							</cite>
							<p>
								{element[key.col].content}
							</p>
						</td>
					);
				}

				if (key.col === 'image_url') {
					if (element.image_url === '--') {
						return (
							<td key={key.id} className="container-link-google">
								<RenderImageAd url="/images/google/image-default.svg" />
							</td>
						);
					}

					return (
						<td key={key.id} className="container-link-google">
							<RenderImageAd url={element.image_url} />
						</td>
					);
				}

				return (
					<td key={key.id}>
						{/* eslint-disable-next-line no-nested-ternary */}
						{key.col === 'ativo' ? (element[key.col] === 1 ? 'Sim' : 'Não') : element[key.col]}
					</td>
				);
			});

			return (
				<tr key={element.id}>
					{cells}
					{valueActions ? <td className="d-flex justify-content-end action-td">{valueActions}</td> : null}
				</tr>
			);
		});
	}

	render() {
		const { elements, type } = this.props;

		if (elements.length === 0) {
			return (
				<p>{(type === 'reports') ? 'Você ainda não possui relatórios.' : 'Nenhum item disponível.'}</p>
			);
		}

		return (
			<div className="table-responsive">
				<table className="table table-hover">
					<thead>
						<tr>
							{this.renderCols()}
						</tr>
					</thead>

					<tbody>
						{this.renderData()}
					</tbody>
				</table>
			</div>
		);
	}
}
